var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('h2Title',{attrs:{"title":"审批流程"}},[_c('div',[_c('span',[_vm._v("返回")])])])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }